import { Academy, TierFeatureKey } from '@court-sync/shared';
import { FeatureGate } from '@/components/FeatureGate';
import { AccountingIntegrationsContent } from './accounting/AccountingIntegrationsContent';
import { ACCOUNTING_FEATURE_DESCRIPTION } from './accounting/accountingIntegrationUi';

interface Props {
  academy: Academy;
}

export function AccountingIntegrationsSection({ academy }: Props) {
  return (
    <FeatureGate
      feature={TierFeatureKey.ACCOUNTING_INTEGRATIONS}
      description={ACCOUNTING_FEATURE_DESCRIPTION}
    >
      <AccountingIntegrationsContent academy={academy} />
    </FeatureGate>
  );
}
